export default __webpack_public_path__ + "2c7a8232208334bc319f896828204861.webp";